module.exports = __webpack_public_path__ + "img/milestones.709258b0.svg";